import classnames from 'classnames';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';

import config from '../../config';
import Icon, { GLYPHS } from './icon';

const DateSwitcher = ({ changeDate, currentDate, startDate, endDate, disabled, className, dateFormat }) => {
  const currentMoment = moment(currentDate);
  const dayBefore = moment(currentMoment).subtract(1, 'day');
  const dayAfter = moment(currentMoment).add(1, 'day');
  const beforeDisabled = dayBefore.isBefore(startDate);
  const afterDisabled = dayAfter.isAfter(endDate);

  return (
    <div className={classnames('o-flexbox o-flexbox--content-align-center', className)}>
      <button
        type="button"
        className={classnames('c-btn c-btn--blank', { 'is-invisible': beforeDisabled })}
        onClick={() => changeDate(dayBefore.format(config.dateFormatISO))}
        disabled={disabled || beforeDisabled}
      >
        <Icon glyph={GLYPHS.chevronLeft} size="small" />
      </button>
      <span className="u-type--light">
        {currentMoment.format(dateFormat)}
      </span>
      <button
        type="button"
        className={classnames('c-btn c-btn--blank', { 'is-invisible': afterDisabled })}
        onClick={() => changeDate(dayAfter.format(config.dateFormatISO))}
        disabled={disabled || afterDisabled}
      >
        <Icon glyph={GLYPHS.chevronRight} size="small" />
      </button>
    </div>
  );
};
DateSwitcher.propTypes = {
  currentDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  changeDate: PropTypes.func,
  startDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  endDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  className: PropTypes.string,
  disabled: PropTypes.bool,
  dateFormat: PropTypes.string,
};
DateSwitcher.defaultProps = {
  currentDate: '',
  changeDate: () => null,
  startDate: '',
  endDate: '',
  className: '',
  disabled: false,
  dateFormat: 'ddd, MMM DD, YYYY',
};
export default DateSwitcher;
